// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--3MW_8";
export var ZoomButton = "styles-module--ZoomButton--2Xe6O";
export var ZoomButton_Label = "styles-module--ZoomButton_Label--3RmGr";
export var LayoutImage = "styles-module--LayoutImage--2a5kB";